import { CloseOutlined } from '@ant-design/icons';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { enhancedPlansSelector } from '@mm/state/selectors/subscriptionSelectors';
import { InputNumber, Radio } from 'antd';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import styles from './BillingLimitsModal.module.css';

type Props = {
  subscription?: SubscriptionModel;
};

export const BillingLimitsModal = ({ subscription }: Props) => {
  const plans = useSelector(enhancedPlansSelector);
  const planName =
    plans.find(plan => plan.planCode === subscription?.planCode)?.shortName ??
    '';
  const [limitOption, setlimitOption] = useState<number>(1);
  const hasLimit = limitOption === 2;
  const defaultSubscriptionPrice = subscription?.basePrice
    ? subscription.basePrice / 100
    : 1;
  const [limitValue, setLimitValue] = useState<number | null>(
    defaultSubscriptionPrice,
  );
  const invalidInput = !limitValue || limitValue < defaultSubscriptionPrice;
  const { closeModal } = useModalActions();

  const billingPeriod = subscription?.billingPeriodLength;
  const customPeriodLength = subscription?.planIntervalLength;

  const period =
    billingPeriod === 'annually'
      ? 'annual'
      : billingPeriod === 'monthly' && (customPeriodLength || 0) > 1
      ? `${customPeriodLength} months`
      : subscription
      ? 'monthly'
      : '';

  return (
    <div className={styles.container}>
      <CloseOutlined
        className={styles.closeIcon}
        onClick={() => closeModal()}
      />

      <div className={styles.title}>
        Setting up the {period} limit
        <div className={styles.description}>
          To be sure you are spending not more then you want, please set up the
          limit
        </div>
      </div>

      <div className={styles.inputWrapper}>
        <Radio.Group
          onChange={e => setlimitOption(e.target.value)}
          value={limitOption}
          buttonStyle="outline"
        >
          <div className={styles.radioInputs}>
            <Radio value={1} className={styles.radioInput}>
              No Limit
            </Radio>

            <div className={styles.limitedRadioInputWrapper}>
              <Radio value={2} className={styles.radioInput}>
                Set a limit
              </Radio>
              <div className={styles.numberInputWithMsg}>
                {hasLimit ? (
                  <InputNumber
                    status={invalidInput ? 'error' : ''}
                    formatter={value =>
                      `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    value={limitValue}
                    onChange={val => setLimitValue(val)}
                  />
                ) : null}

                {hasLimit && (
                  <div
                    className={classNames(styles.errorMessage, {
                      [styles.invalidMessage]: invalidInput,
                    })}
                  >
                    Your limit should not be less than your{' '}
                    <span style={{ textTransform: 'capitalize' }}>
                      {planName}
                    </span>{' '}
                    Plan cost — ${defaultSubscriptionPrice}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Radio.Group>
      </div>

      <PrimaryButton
        onClick={() => console.log(limitValue)}
        className={styles.button}
        disabled={hasLimit && invalidInput}
      >
        Set up new Limit
      </PrimaryButton>
    </div>
  );
};
